import type { paths } from "@/api-schema";
import { useBrandByUuidQuery } from "@/common/api/brand/use-brand-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { BrandUpdateFormFields } from "./_components/update-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/brand/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/brand/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useBrandByUuidQuery}
      notFoundProps={{
        title: t("masterdata:BrandNotFound"),
        message: t("masterdata:BrandDoesNotExist"),
        description: t("masterdata:CheckBrandIdOrContactSupport"),
        backTo: "~/masterdata/brand",
        backToLabel: t("masterdata:BackToBrandOverview"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditBrand");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <BrandUpdateFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
